import React, { useState, useEffect, useRef } from "react";
import img10 from "../assets/img/image 10.png";
import img11 from "../assets/img/image 11.png";
import img6 from "../assets/img/image 6.png";
import img5 from "../assets/img/Replace image.png";
import "./RecommendedForYou.css";
import { ChevronLeft, ChevronRight } from "lucide-react";

// items: either [{ id, image, title, description, href }] or [{ label, url }]
const DEFAULT_ITEMS = [
  {
    label: "New Feature In Store",
    url: "https://play.google.com/store/apps/details?id=com.oldmutual.myoldmutual",
    description: "Discover, learn and do more with highlights",
    image: img5,
    isNew: true,
  },
  {
    label: "Travel Insurance",
    modalTitle: "International Travel Insurance",
    url: "https://www.oldmutual.com.gh/personal/international-travel-insurance/",
    applyUrl: "https://www.oldmutual.com.gh/travel-insurance/",
    learnMoreUrl: "https://www.oldmutual.com.gh/personal/international-travel-insurance/",
    description: "Travel loss insurance.",
    modalDescription: "Up to €30,000 emergency medical coverage abroad",
    benefits: [
      "Up to €30,000 emergency medical expenses cover",
      "€3,000 permanent total disability cover",
    ],
    image: img6,
  },
  {
    label: "Educator Plan",
    url: "https://www.oldmutual.com.gh/personal/education-plan/",
    applyUrl: "https://www.oldmutual.com.gh/personal/education-plan/education-plan-form/",
    learnMoreUrl: "https://www.oldmutual.com.gh/personal/education-plan/",
    description: "Cover yourself, your parents and more",
    modalDescription:
      "Secure your child's education with life coverage and savings",
    benefits: [
      "Child Life Assurance Protection",
      "Accumulated Fund Payback after 24 months",
      "Parent Disability Protection",
      "Partial withdrawals after 2 years",
    ],
    image: img10,
  },

  {
    label: "Mvest Personal Pensions",
    url: "https://www.oldmutual.com.gh/personal/mvest-personal-pension-scheme/",
    applyUrl: "https://www.oldmutual.com.gh/mvest/",
    learnMoreUrl: "https://www.oldmutual.com.gh/personal/mvest-personal-pension-scheme/",
    description: "Secure your future with our flexible pension scheme",
    modalDescription: "Secure your personal pension for the future",
    benefits: [
      "Competitive returns",
      "Lump-Sum payment",
      "Easy application and exit process",
      "Access to life insurance",
      "Access to personal loans",
      "Different and convenient modes of contribution",
      "Benefit payment is made within 72 hours",
      "24/7 online portal",
    ],
    image: "https://eu-images.contentstack.com/v3/assets/bltdd392fd32dda3ce8/blt3d1a427c7ce1fe4c/67977d588594a46945a82eea/Mvest_Personal_Pension_Scheme_card.jpg?width=288&height=146&format=webp&quality=100",
  },
  {
    label: "Personal Accident",
    url: "https://www.oldmutual.com.gh/personal/personal-accident-policy/",
    applyUrl: "https://www.oldmutual.com.gh/personal-accident/",
    learnMoreUrl: "https://www.oldmutual.com.gh/personal/personal-accident-policy/",
    description: "Financial protection against accidental injuries and disabilities",
    modalDescription: "Financial protection against accidental injuries and disabilities",
    benefits: [
      "Accidental death",
      "Permanent disability of the insured arising from the accident.",
      "A temporary total disability that makes you lose your source of income.",
      "€3,000 permanent total disability cover",
    ],
    image: img11,
  },
  {
    label: "Special Investment Plan",
    url: "https://www.oldmutual.com.gh/personal/special-investment-plan/special-investment-plan-form//",
    applyUrl: "https://www.oldmutual.com.gh/personal/special-investment-plan/special-investment-plan-form/",
    learnMoreUrl: "https://www.oldmutual.com.gh/personal/special-investment-plan/",
    description: "Grow your wealth with our specialized investment options",
    modalDescription: "Long-term savings with life coverage and flexible withdrawals",
    benefits: [
      "Financial security",
      "Partial withdrawals of up to 50% of the total monthly contributions once in a year",
      "If the policyholder passes away, the beneficiary will receive either the death benefit or the total contributions, whichever is greater.",
    ],
    image: "https://eu-images.contentstack.com/v3/assets/bltdd392fd32dda3ce8/bltcd558c2d947e6d74/67977dba6c68245d273898d6/Special_Investment_Plan_card.jpg?width=288&height=146&format=webp&quality=100",
  },
  {
    label: "Mvest Personal Pensions",
    url: "https://www.oldmutual.com.gh/personal/special-investment-plan/special-investment-plan-form//",
    applyUrl: "https://www.oldmutual.com.gh/personal/special-investment-plan/special-investment-plan-form/",
    learnMoreUrl: "https://www.oldmutual.com.gh/personal/special-investment-plan/",
    description: "Grow your wealth with our specialized investment options",
    modalDescription: "Long-term savings with life coverage and flexible withdrawals",
    benefits: [
      "Financial security",
      "Partial withdrawals of up to 50% of the total monthly contributions once in a year",
      "If the policyholder passes away, the beneficiary will receive either the death benefit or the total contributions, whichever is greater.",
    ],
    image: "https://eu-images.contentstack.com/v3/assets/bltdd392fd32dda3ce8/bltcd558c2d947e6d74/67977dba6c68245d273898d6/Special_Investment_Plan_card.jpg?width=288&height=146&format=webp&quality=100",
  },
];

function normalizeItems(items) {
  const source =
    Array.isArray(items) && items.length > 0 ? items : DEFAULT_ITEMS;
  return source.map((it, idx) => {
    // If item has label/url (user-provided list), map to our shape
    if (it.label && (it.url || it.href)) {
      // Preserve any existing fields (benefits, modalDescription, modalTitle, etc.)
      return {
        ...it,
        id: it.id || `item-${idx}`,
        image:
          it.image ||
          `https://via.placeholder.com/64/cccccc/ffffff?text=${encodeURIComponent(
            (it.label.match(/\b(\w)/g) || []).slice(0, 2).join("")
          )}`,
        label: it.label,
        title: it.title || it.label, // Keep both for compatibility
        description: it.description || "",
        href: it.href || it.url,
        isNew: it.isNew || false,
        applyUrl: it.applyUrl || it.href || it.url || "#",
        learnMoreUrl: it.learnMoreUrl || it.href || it.url || "#"
      };
    }
    // otherwise assume already in desired shape (or partially shaped)
      return {
      id: it.id || `item-${idx}`,
      image: it.image || "https://via.placeholder.com/64",
      label: it.label || it.title || "Item",
      title: it.title || it.label || "Item", // Keep both for compatibility
      description: it.description || "",
      href: it.href || it.url || "#",
      isNew: it.isNew || false,
      applyUrl: it.applyUrl || it.href || it.url || "#",
      learnMoreUrl: it.learnMoreUrl || it.href || it.url || "#"
    };
  });
}

export default function RecommendedForYou({ items = [], title = "" }) {
  const list = normalizeItems(items);
  const [visible, setVisible] = useState(false);
  const [active, setActive] = useState(null);
  const scrollRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return undefined;

    const updateScrollState = () => {
      const el = scrollRef.current;
      if (!el) return;
      setCanScrollLeft(el.scrollLeft > 8);
      setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 8);
    };

    updateScrollState();
    container.addEventListener("scroll", updateScrollState);
    window.addEventListener("resize", updateScrollState);
    return () => {
      container.removeEventListener("scroll", updateScrollState);
      window.removeEventListener("resize", updateScrollState);
    };
  }, []);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    requestAnimationFrame(() => {
      setCanScrollLeft(el.scrollLeft > 8);
      setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 8);
    });
  }, [list.length]);

  const scrollCards = (direction) => {
    const container = scrollRef.current;
    if (!container) return;
    const delta = direction === "left" ? -280 : 280;
    container.scrollBy({ left: delta, behavior: "smooth" });
  };

  function openModal(item) {
    setActive(item);
    setVisible(true);
  }

  function closeModal() {
    setVisible(false);
    setActive(null);
  }

  // Split a label into first word and the rest. We render as two spans
  // so CSS can place the first word on the first line and the rest below on small screens.
  const renderLabelSplit = (label) => {
    if (!label) return null;
    const words = label.split(/\s+/).filter(Boolean);
    if (words.length === 1) return <span className="rfy-head-first">{label}</span>;

    // Special cases for better line breaks - ALL labels must have proper spacing
    // Note: {' '} adds a visible space between inline spans on desktop
    if (label === 'New Feature In Store') {
      return (
        <>
          <span className="rfy-head-first">New&nbsp;Feature</span>
          {' '}
          <span className="rfy-head-rest">
            <span className="rfy-head-pair">In&nbsp;Store</span>
          </span>
        </>
      );
    }
    if (label === 'Travel Insurance') {
      return (
        <>
          <span className="rfy-head-first">Travel</span>
          {' '}
          <span className="rfy-head-rest">
            <span className="rfy-head-pair">Insurance</span>
          </span>
        </>
      );
    }
    if (label === 'Educator Plan') {
      return (
        <>
          <span className="rfy-head-first">Educator</span>
          {' '}
          <span className="rfy-head-rest">
            <span className="rfy-head-pair">Plan</span>
          </span>
        </>
      );
    }
    if (label === 'Personal Accident') {
      return (
        <>
          <span className="rfy-head-first">Personal</span>
          {' '}
          <span className="rfy-head-rest">
            <span className="rfy-head-pair">Accident</span>
          </span>
        </>
      );
    }
    if (label === 'Special Investment Plan') {
      return (
        <>
          <span className="rfy-head-first rfy-head-three">Special</span>
          {' '}
          <span className="rfy-head-rest rfy-head-rest-three">
            <span className="rfy-head-pair">Investment&nbsp;Plan</span>
          </span>
        </>
      );
    }
    if (label === 'Mvest Personal Pensions') {
      return (
        <>
          <span className="rfy-head-first rfy-head-three">Mvest</span>
          {' '}
          <span className="rfy-head-rest rfy-head-rest-three">
            <span className="rfy-head-pair">Personal&nbsp;Pensions</span>
          </span>
        </>
      );
    }

    // For 2+ words, first word on top line, rest on bottom line
    const firstWord = words[0];
    const rest = words.slice(1).join('\u00A0'); // Use non-breaking space to keep words together
    return (
      <>
        <span className="rfy-head-first">{firstWord}</span>
        {' '}
        <span className="rfy-head-rest">
          <span className="rfy-head-pair">{rest}</span>
        </span>
      </>
    );
  };
  // Actions are now rendered as anchors in the modal; navigation handled via hrefs

  return (
    <section className="rfy-wrapper" aria-labelledby="rfy-heading">
      <h3 id="rfy-heading" className="rfy-title">
        {title}
      </h3>
      <div className="rfy-scroll-wrapper">
        <button
          type="button"
          className="rfy-scroll-btn"
          aria-label="Scroll cards left"
          onClick={() => scrollCards("left")}
          disabled={!canScrollLeft}
        >
          <ChevronLeft size={18} />
        </button>
        <div className="rfy-container" role="list" ref={scrollRef}>
          {list.map((it) => (
            <button
              key={it.id}
              type="button"
              className="rfy-card"
              role="listitem"
              aria-label={`${it.title} — ${it.description}`}
              onClick={() => openModal(it)}
            >
              <div className="rfy-media">
                {it.isNew && <div className="rfy-new-badge">NEW</div>}
                <img src={it.image} alt={it.title} />
              </div>
                      <div className="rfy-body">
                        <div className="rfy-head" aria-hidden={false}>
                          {renderLabelSplit(it.label || it.title)}
                        </div>
                        <div className="rfy-desc">{it.description}</div>
                      </div>
            </button>
          ))}
        </div>
        <button
          type="button"
          className="rfy-scroll-btn rfy-scroll-btn-right"
          aria-label="Scroll cards right"
          onClick={() => scrollCards("right")}
          disabled={!canScrollRight}
        >
          <ChevronRight size={18} />
        </button>
        <div
          className="rfy-scroll-fade rfy-scroll-fade-left"
          aria-hidden="true"
          style={{ opacity: canScrollLeft ? 1 : 0 }}
        />
        <div
          className="rfy-scroll-fade rfy-scroll-fade-right"
          aria-hidden="true"
          style={{ opacity: canScrollRight ? 1 : 0 }}
        />
      </div>

      {/* Custom Modal - following PaymentHistoryModal pattern */}
      {visible && (
        <div
          className="rfy-custom-modal-overlay"
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(0,0,0,0.5)',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '16px',
          }}
          onClick={closeModal}
        >
          <div
            className="rfy-custom-modal"
            style={{
              background: '#fff',
              borderRadius: 18,
              minWidth: 320,
              maxWidth: 720,
              width: '100%',
              boxShadow: '0 8px 40px 0 rgba(0,0,0,0.13)',
              padding: 0,
              position: 'relative',
              display: 'flex',
              flexDirection: 'column',
              maxHeight: '85vh',
            }}
            onClick={e => e.stopPropagation()}
          >
            {/* Header */}
            <div className="rfy-custom-modal-header" style={{ padding: '24px 32px 20px 32px' }}>
              <div style={{ 
                fontWeight: 800, 
                color: '#222', 
                marginBottom: 6, 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'space-between' 
              }}>
                <span style={{ fontSize: 18 }}>{active ? active.modalTitle || active.label || active.title : ""}</span>
                <button 
                  onClick={closeModal}
                  style={{ 
                    background: 'none', 
                    border: 'none', 
                    fontSize: 22, 
                    color: '#888', 
                    cursor: 'pointer', 
                    marginLeft: 12, 
                    fontWeight: 700, 
                    lineHeight: 1 
                  }} 
                  aria-label="Close"
                >
                  ×
                </button>
              </div>
              <p style={{ color: '#888', fontSize: 15, marginBottom: 0, marginTop: 0 }}>
                {active?.modalDescription || active?.description || ''}
              </p>
            </div>

            {/* Content */}
            <div className="rfy-custom-modal-body" style={{ 
              padding: '0 32px 32px 32px', 
              overflowY: 'auto', 
              flex: 1,
            }}>
              {active && (
                <div className="rfy-modal-content">
                  {active.benefits && active.benefits.length > 0 && (
                    <div className="rfy-benefits-section">
                      <h4 className="rfy-benefits-title">Key Benefits</h4>
                      <ul className="rfy-benefits-list">
                        {active.benefits.map((benefit, index) => (
                          <li key={index} className="rfy-benefit-item">
                            <span className="rfy-benefit-check">✓</span>
                            {benefit}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}

                  <div className="rfy-modal-actions d-flex justify-content-center gap-3 flex-wrap" style={{ marginTop: 16 }}>
                    {active.isNew ? (
                      <>
                        <a
                          href="https://apps.apple.com/us/app/old-mutual/id1481355805"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-white mb-0 flex-fill"
                          style={{ padding: '10px 18px', fontWeight: 600, borderRadius: '50px', minWidth: '140px' }}
                        >
                          <i className="bi bi-apple" style={{ fontSize: 18, marginRight: 8 }} />
                          Apple Store
                        </a>
                        <a
                          href={active.href || "#"}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-primary mb-0 flex-fill"
                          style={{ padding: '10px 18px', fontWeight: 600, borderRadius: '50px', minWidth: '140px' }}
                        >
                          <i className="bi bi-android2" style={{ fontSize: 18, marginRight: 8 }} />
                          Play Store
                        </a>
                      </>
                    ) : (
                      <>
                        <a
                          href={active.applyUrl || active.href || "#"}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-primary mb-0 flex-fill"
                          style={{ padding: '10px 18px', fontWeight: 600, borderRadius: '50px', minWidth: '120px' }}
                        >
                          Apply Now
                        </a>
                        <a
                          href={active.learnMoreUrl || active.href || "#"}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-white mb-0 flex-fill"
                          style={{ padding: '10px 18px', fontWeight: 600, borderRadius: '50px', minWidth: '120px' }}
                        >
                          Learn More
                        </a>
                      </>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
